import { FiPhone, FiMail, FiMapPin } from "react-icons/fi";

// ================= CONTACT CARD =================
export function ContactCard() {
  // Theme colors
  const gold = "#fdca00";
  const blue = "#0393da";

  return (
    <section className="pt-16 pb-8" style={{ background: "#fff" }}>
      <div className="max-w-6xl mx-auto px-6">
        <h2
          className="text-4xl md:text-5xl font-semibold font-serif mb-10"
          style={{ color: blue }}
        >
          Contacts
        </h2>

        <div
          className="rounded-3xl p-8 flex flex-col gap-8 shadow-xl max-w-2xl"
          style={{
            background: "#fffbea",
            border: `2px solid ${gold}`,
          }}
        >
          <div className="space-y-4 text-sm" style={{ color: blue }}>
            <div className="flex items-center gap-2">
              <span className="font-semibold" style={{ color: gold }}>
                GST No.:
              </span>
              <span className="font-mono">08AWEPV4114A1ZU</span>
            </div>
            <div className="flex items-center gap-2">
              <FiPhone className="text-base" />
              <span className="font-semibold" style={{ color: gold }}>
                Call Us:
              </span>
              <a
                href="tel:+919257028601"
                className="underline"
                style={{ color: "inherit" }}
              >
                +91-9257028601
              </a>
            </div>
            <div className="flex items-center gap-2">
              <FiMail className="text-base" />
              <span className="font-semibold" style={{ color: gold }}>
                Email:
              </span>
              <a
                href="mailto:Westerndrymix@gmail.com"
                className="underline"
                style={{ color: "inherit", fontWeight: 600 }}
              >
                Westerndrymix@gmail.com
              </a>
            </div>
            <div className="flex items-start gap-2">
              <FiMapPin className="text-base mt-0.5" />
              <div>
                <span className="font-semibold" style={{ color: gold }}>
                  Address:
                </span>{" "}
                Western Drymix
                <br />
                Plot No -205, Near Rathi Chowk, matsya industrial area
                <br />
                Alwar, Rajasthan 301030
              </div>
            </div>
          </div>
        </div>

        <p className="mt-10" style={{ color: blue }}>
          Didn’t find what you were looking for on our site? Contact us!
        </p>
      </div>
    </section>
  );
}
